import { fg } from '@atlassian/jira-feature-gating';

const AiGeneratedWorkItemNextActionsM2RelayProvider = {
	get(): boolean {
		return (
			fg('proactive_ai-generated_next_best_actions_fg') ||
			fg('triage_agent_actions_in_nba_panel_fg')
		);
	},
};

export default AiGeneratedWorkItemNextActionsM2RelayProvider;
